angular.module('app.filters').filter('sdiHeoVeo', () => {
    return function(val) {
        const heo_ui = val[0];
        const veo_mv = val[1];
        if (heo_ui && (heo_ui != 0) && veo_mv && (veo_mv != 0)) {
            return `HEO: ${heo_ui} UI, VEO: ${veo_mv} mV`
        } else {
            return '';
        }
    }
});


// WEBPACK FOOTER //
// ./filters/sdi_heo_veo.js